import axios from 'axios';
import { getToken, handleUnauthorized, captureRefreshedToken } from './authToken';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3101/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    captureRefreshedToken(response.headers);
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      handleUnauthorized();
    }
    return Promise.reject(error);
  }
);

export const alunosAPI = {
  getAll: () => api.get('/alunos'),
  getById: (id) => api.get(`/alunos/${id}`),
  create: (data) => api.post('/alunos', data),
  update: (id, data) => api.put(`/alunos/${id}`, data),
  delete: (id) => api.delete(`/alunos/${id}`),
};

export const academiasAPI = {
  getAll: () => api.get('/academias'),
  getById: (id) => api.get(`/academias/${id}`),
  create: (data) => api.post('/academias', data),
  update: (id, data) => api.put(`/academias/${id}`, data),
  delete: (id) => api.delete(`/academias/${id}`),
};

export const categoriasAPI = {
  getAll: () => api.get('/categorias'),
  getById: (id) => api.get(`/categorias/${id}`),
  create: (data) => api.post('/categorias', data),
  update: (id, data) => api.put(`/categorias/${id}`, data),
  delete: (id) => api.delete(`/categorias/${id}`),
};

export const chavesAPI = {
  getAll: () => api.get('/chaves'),
  getById: (id) => api.get(`/chaves/${id}`),
  gerar: (data) => api.post('/chaves/gerar', data),
  getHtml: (id) => api.get(`/chaves/${id}/html`),
  getPdf: (id) => api.get(`/chaves/${id}/pdf`, { responseType: 'blob' }),
  delete: (id) => api.delete(`/chaves/${id}`),
  updateResultados: (id, resultados) => api.put(`/chaves/${id}/resultados`, { resultados }),
};

export const professoresAPI = {
  getAll: () => api.get('/professores'),
  getByAcademia: (academiaId) => api.get(`/professores/academia/${academiaId}`),
  getById: (id) => api.get(`/professores/${id}`),
  create: (data) => api.post('/professores', data),
  update: (id, data) => api.put(`/professores/${id}`, data),
  delete: (id) => api.delete(`/professores/${id}`),
};

export const inscricoesAPI = {
  listarPorCampeonato: (campeonatoId) => api.get(`/campeonatos/${campeonatoId}/inscricoes`),
  confirmar: (id) => api.put(`/inscricoes/${id}/confirmar`),
  cancelar: (id) => api.delete(`/inscricoes/${id}`),
};

export const authAPI = {
  login: (email, senha) => api.post('/auth/login', { email, senha }),
  me: () => api.get('/auth/me'),
};

export const cepAPI = {
  buscar: (cep) => api.get(`/cep/${cep}`),
};

export const financeiroAPI = {
  resumo: () => api.get('/financeiro/resumo'),
};

export default api;
